import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import userReducer from "../features/userSlice";
import tenpoStatusReducer from "../features/tenpoStatusSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    tenpoStatus: tenpoStatusReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type AppDispatch = typeof store.dispatch;
